import React from "react";
import { colors } from "~/utils/colors";
import rgba from "polished/lib/color/rgba";

export const SubmitButton: React.FC<{
  disabled: boolean;
}> = ({ disabled }) => {
  return (
    <>
      <style jsx>{`
        .wrapper {
          display: flex;
          justify-content: center;
        }
        .button {
          background-position: calc(100% - 30px) center;
          background-size: 15px auto;
          background: linear-gradient(
            270deg,
            #ea3375 -73%,
            #ea3572 -69.4%,
            #eb4656 -31.72%,
            #ec5145 1.32%,
            #ec553f 25.96%,
            #ec8317 100%
          );
          border-radius: 50px;
          position: relative;
          display: block;
          text-align: center;
          padding: 15px 20px;
          box-shadow: 0 0 12px ${rgba(colors.black, 0.1)};
          color: ${colors.white};
          font-size: 15px;
          font-weight: bold;
          transition: all 0.15s ease-out;
          max-width: 500px;
          width: 100%;
          opacity: 1;
        }
        .button:hover {
          opacity: 0.8;
        }
        .button:disabled {
          background: none;
          background-color: #ccc;
          color: ${colors.gray2};
          cursor: not-allowed;
          box-shadow: none;
        }
        .button:disabled:hover {
          opacity: 1;
        }
      `}</style>
      <div className="wrapper">
        <input className="button" type="submit" value="送信する" disabled={disabled} />
      </div>
    </>
  );
};
